// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"39589e63","359":"9502188c","633":"1537e6e4","678":"1c024395","819":"407d047a","877":"1537e6e4","899":"78a43d95"}[chunkId] + ".css";
};